<script>
import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "UserSplashImage",
  extends: BaseImageElement,
  mixins: [UserProfilePageElementMixin, FallbackImageElementMixin],
  elementPanelSettings: {
    displayName: "User Splash Image",
    displayIcon: "document",
    elementGroup: "userProfile",
    elementType: "element",
  },
  computed: {
    imageSrc() {
      return this.entity.splashImageUrl;
    },
  },
};
</script>
